var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.tag,{tag:"component",staticClass:"base-menu-item-content d-flex align-self-stretch align-items-stretch justify-content-between",class:{
        [`${_setup.theme}`]: !!_setup.theme,
        [`${_setup.type}`]: !!_setup.type,
    }},[_vm._t("prefix"),_vm._v(" "),_c('span',{staticClass:"main-content-container d-flex align-items-center flex-fill"},[_vm._t("default")],2),_vm._v(" "),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }